const FloatingSocialMediaIcons = ({className, id}) =>
    <aside className={`social-media ${className}`} id={id ?? null}>
        <div className="social-media__icon-container">
            <div className="social-media__icon-background social-media__icon-background--github" />
            <a className="social-media__icon" href="https://github.com/tobias290" target="_blank" rel="noopener noreferrer"><i className="fab fa-github-alt" /></a>
        </div>
        <div className="social-media__icon-container">
            <div className="social-media__icon-background social-media__icon-background--linkedin" />
            <a className="social-media__icon" href="https://www.linkedin.com/in/toby-essex" target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin-in" /></a>
        </div>
        <div className="social-media__icon-container">
            <div className="social-media__icon-background social-media__icon-background--facebook" />
            <a className="social-media__icon" href="https://www.facebook.com/toby.essextoby" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f" /></a>
        </div>
    </aside>;

export default FloatingSocialMediaIcons;
